import MobileMenu from './MobileMenu';
export default MobileMenu;
